import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'expiresSoon',
  standalone: false, // eslint-disable-line
})
export class ExpiresSoonPipe implements PipeTransform {
  transform(date: string): boolean {
    const targetDate: DateTime<true> | DateTime<false> = DateTime.fromISO(date).startOf('day');
    const today: DateTime<true> = DateTime.now().startOf('day');
    const diffInDays: number = targetDate.diff(today, 'days').days;

    return diffInDays >= 0 && diffInDays < 14;
  }
}
